import GoToInvestmentModal from "./GoToInvestmentModal";

export default GoToInvestmentModal;
